// extracted by mini-css-extract-plugin
export var button = "_dd-4";
export var hasDarkBackground = "_dd-7";
export var hasLightBackground = "_dd-6";
export var iconWrapper = "_dd-0";
export var large = "_dd-2";
export var medium = "_dd-1";
export var small = "_dd-5";
export var xsmall = "_dd-3";